export default __webpack_public_path__ + "static/media/feature-questions.fdc216ef.svg";